module.exports = __webpack_public_path__ + "static/img/pic_zhutu@2x.09d0a82a.png";